<template>
    <EmergencyPreparednessSection />
    <EvacuationSection />
</template>

<script src="./EmergencyPreparedness.ts"></script>
